module.exports = __webpack_public_path__ + "static/header-4621fa6d07444c21760dde172d17a5c3.jpg";